webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadImage = loadImage;
exports.loadSvg = loadSvg;
function loadImage(src) {
    return new Promise(function (resolve) {
        var image = document.createElement('img');
        image.src = src;

        if (image.complete && image.naturalWidth) {
            resolve(image);
        } else {
            image.addEventListener('load', function () {
                return resolve(image);
            });
        }
    });
}

function loadSvg(src) {
    return new Promise(function (resolve, reject) {
        fetch(src).then(function (response) {
            if (response.ok && response.headers.get('Content-Type') === 'image/svg+xml') {
                return response.text();
            }

            reject(response.status);
            return null;
        }).then(function (text) {
            var parser = new DOMParser();
            var svg = parser.parseFromString(text, 'image/svg+xml').querySelector('svg');
            resolve(svg);
        });
    });
}

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EventBus = undefined;

var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventBus = exports.EventBus = new _vue2.default();

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(13);

var _components = __webpack_require__(14);

var components = _interopRequireWildcard(_components);

var _mquery = __webpack_require__(84);

var mediaquery = _interopRequireWildcard(_mquery);

__webpack_require__(85);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// mediaquery

mediaquery.add({
    mediaquery: '(max-width: 768px)',
    name: 'small'
});

mediaquery.add({
    mediaquery: '(min-width: 769px) and (max-width: 1024px)',
    name: 'medium'
});

mediaquery.add({
    mediaquery: '(min-width: 1025px) and (max-width: 1440px)',
    name: 'large'
});

mediaquery.add({
    mediaquery: '(min-width: 1441px)',
    name: 'wide'
});

// theme

window.theme = {
    modules: {
        components: components
    },
    mediaquery: mediaquery
};

window.Vue = _vue2.default;

// element locale setup
var localeInterval = setInterval(function () {
    if (ELEMENT && ELEMENT.lang && ELEMENT.lang.it) {
        var lang = _lodash2.default.cloneDeep(ELEMENT.lang.it);
        lang.el.datepicker.year = '';
        ELEMENT.locale(lang);
        clearInterval(localeInterval);
    }

    if (ELEMENT && ELEMENT.lang && ELEMENT.lang.en) {
        var _lang = _lodash2.default.cloneDeep(ELEMENT.lang.en);
        _lang.el.datepicker.year = '';
        ELEMENT.locale(_lang);
        clearInterval(localeInterval);
    }

    if (ELEMENT && ELEMENT.lang && ELEMENT.lang.es) {
        var _lang2 = _lodash2.default.cloneDeep(ELEMENT.lang.es);
        _lang2.el.datepicker.year = '';
        ELEMENT.locale(_lang2);
        clearInterval(localeInterval);
    }
}, 100);

setTimeout(function () {
    clearInterval(localeInterval);
}, 7000);

// init components
_lodash2.default.each(theme.modules, function (module) {
    if (_lodash2.default.isFunction(module.initialize)) {
        module.initialize(theme);
    }
});

// ready components
Promise.resolve().then(function () {
    return new Promise(function (resolve) {
        if (document.readyState === 'loading') {
            document.addEventListener('readystatechange', function () {
                return resolve();
            });
            return;
        } else {
            resolve();
        }
    });
}).then(function () {
    _lodash2.default.each(theme.modules, function (module) {
        if (_lodash2.default.isFunction(module.ready)) {
            module.ready(theme);
        }
    });
});

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__.p = window.__themeUrl + "/dist/";

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.config = exports.instances = undefined;
exports.initialize = initialize;
exports.ready = ready;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

var _index = __webpack_require__(15);

var _store = __webpack_require__(83);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var contentEl = null;

var instances = exports.instances = [];

var config = exports.config = {
    contentSelector: '.content',
    componentAttribute: 'data-component',
    componentId: 'data-id'
};

function initialize(mtwp) {
    _lodash2.default.defer(function () {
        if (mtwp.modules.pageLoader) {
            // destroy and remove components before content replacement
            mtwp.modules.pageLoader.config.hooks.beforeContentReplace.push(function () {
                return onBeforeContentReplace();
            });
            // parse components after page loader content replacement
            mtwp.modules.pageLoader.config.hooks.afterContentReplace.push(function () {
                return parse();
            });
        }
    });
}

function ready(mtwp) {
    contentEl = document.querySelector(config.contentSelector);
    parse();
}

function onBeforeContentReplace() {
    // destroy and remove content components
    _lodash2.default.each(_lodash2.default.filter(instances, function (component) {
        return component.scope === 'content';
    }), function (component) {
        component.$destroy();
        exports.instances = instances = _lodash2.default.without(instances, component);
    });
}

function parse() {
    var componentsEls = document.querySelectorAll('[' + config.componentAttribute + ']');
    _lodash2.default.each(componentsEls, function (el) {
        var componentName = _lodash2.default.kebabCase(el.getAttribute(config.componentAttribute));
        (0, _index.importComponent)(componentName).then(function (componentObject) {
            // quit if no component is found
            if (!componentObject) {
                return;
            }

            componentObject = _lodash2.default.cloneDeep(componentObject);

            // test if component is global or not
            var scope = 'global';
            var parentEl = el;

            while (parentEl && parentEl.parentNode) {
                if (parentEl === contentEl) {
                    scope = 'content';
                    parentEl = null;
                } else {
                    parentEl = parentEl.parentNode;
                }
            }

            // add store to the vue instance
            componentObject.component.store = _store2.default;

            // extend data object
            if (_lodash2.default.isPlainObject(componentObject.component.data)) {
                componentObject.component.data = _lodash2.default.assign(componentObject.component.data, { scope: scope });
            } else {
                componentObject.component.data = { scope: scope };
            }

            // set data & remove window object
            var componentId = el.getAttribute(config.componentId);
            if (window['__' + componentId]) {
                componentObject.component.data = _lodash2.default.assign(componentObject.component.data, window['__' + componentId]);
                delete window['__' + componentId];
            }

            // remove data script
            var dataScript = el.parentNode.querySelector('#data-' + componentId);
            if (dataScript) {
                dataScript.parentNode.removeChild(dataScript);
            }

            // set template
            componentObject.component.template = nodeToVueTemplate(el);

            // create component and then mount the element
            var componentInstance = new _vue2.default(componentObject.component);
            componentInstance.$mount(el);

            // remove component attribute / id
            componentInstance.$el.removeAttribute(config.componentAttribute);
            componentInstance.$el.removeAttribute(config.componentId);

            // add the instance to the set
            instances.push(componentInstance);
        }).catch(function (str) {
            return console.error(str);
        });
    });
}

function nodeToVueTemplate(el) {
    var elCopy = el.cloneNode(true);
    replaceAttributesToVueTemplate(elCopy);
    return elCopy.outerHTML.replace(/\s\s+/g, ' ');
}

function replaceAttributesToVueTemplate(el) {
    if (el.tagName.toLowerCase() === 'svg') {
        return;
    }

    // replace attributes
    if (el.hasAttributes()) {
        var elAttributes = _lodash2.default.map(el.attributes, function (attribute) {
            return {
                name: attribute.name.toLowerCase(),
                value: attribute.value
            };
        });

        for (var i = elAttributes.length - 1; i >= 0; i--) {
            var attrName = elAttributes[i].name;
            var attrValue = elAttributes[i].value;
            var bindMatch = attrName.match(/^data\-bind\-(.+)$/);
            var onMatch = attrName.match(/^data\-on\-(.+)$/);
            var vueAttributeName = null;

            // bind directive
            if (bindMatch && bindMatch[1]) {
                vueAttributeName = 'v-bind:' + bindMatch[1];
            }

            // on directive
            if (onMatch && onMatch[1]) {
                vueAttributeName = 'v-on:' + onMatch[1];
            }

            // other directives
            switch (attrName) {
                case 'data-html':
                    vueAttributeName = 'v-html';
                    break;

                case 'data-text':
                    vueAttributeName = 'v-text';
                    break;

                case 'data-show':
                    vueAttributeName = 'v-show';
                    break;

                case 'data-if':
                    vueAttributeName = 'v-if';
                    break;

                case 'data-else':
                    vueAttributeName = 'v-else';
                    break;

                case 'data-else-if':
                    vueAttributeName = 'v-else-if';
                    break;

                case 'data-for':
                    vueAttributeName = 'v-for';
                    break;

                case 'data-model':
                    vueAttributeName = 'v-model';
                    break;

                case 'data-pre':
                    vueAttributeName = 'v-pre';
                    break;

                case 'data-cloak':
                    vueAttributeName = 'v-cloak';
                    break;

                case 'data-once':
                    vueAttributeName = 'v-once';
                    break;

                case 'data-ref':
                    vueAttributeName = 'ref';
                    break;
            }

            if (vueAttributeName) {
                el.removeAttribute(attrName);
                el.setAttribute(vueAttributeName, attrValue);
            }
        }
    }

    // recursively convert children attributes
    if (el.children.length) {
        for (var _i = el.children.length - 1; _i >= 0; _i--) {
            replaceAttributesToVueTemplate(el.children[_i]);
        }
    }
}

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.importComponent = importComponent;

var _accommodationContent = __webpack_require__(16);

var AccommodationContent = _interopRequireWildcard(_accommodationContent);

var _accommodationsSlider = __webpack_require__(18);

var AccommodationsSlider = _interopRequireWildcard(_accommodationsSlider);

var _breadcrumbs = __webpack_require__(20);

var Breadcrumbs = _interopRequireWildcard(_breadcrumbs);

var _contactsContent = __webpack_require__(22);

var ContactsContent = _interopRequireWildcard(_contactsContent);

var _faqContent = __webpack_require__(24);

var FaqContent = _interopRequireWildcard(_faqContent);

var _faqList = __webpack_require__(26);

var FaqList = _interopRequireWildcard(_faqList);

var _footer = __webpack_require__(28);

var Footer = _interopRequireWildcard(_footer);

var _fullImage = __webpack_require__(30);

var FullImage = _interopRequireWildcard(_fullImage);

var _fullSlider = __webpack_require__(32);

var FullSlider = _interopRequireWildcard(_fullSlider);

var _homePackages = __webpack_require__(35);

var HomePackages = _interopRequireWildcard(_homePackages);

var _infoBoxes = __webpack_require__(37);

var InfoBoxes = _interopRequireWildcard(_infoBoxes);

var _latestPosts = __webpack_require__(39);

var LatestPosts = _interopRequireWildcard(_latestPosts);

var _newsletterBar = __webpack_require__(41);

var NewsletterBar = _interopRequireWildcard(_newsletterBar);

var _mobileMenu = __webpack_require__(43);

var MobileMenu = _interopRequireWildcard(_mobileMenu);

var _offersSlider = __webpack_require__(45);

var OffersSlider = _interopRequireWildcard(_offersSlider);

var _oneColumn = __webpack_require__(47);

var OneColumn = _interopRequireWildcard(_oneColumn);

var _packageContent = __webpack_require__(49);

var PackageContent = _interopRequireWildcard(_packageContent);

var _packagesBox = __webpack_require__(51);

var PackagesBox = _interopRequireWildcard(_packagesBox);

var _packagesGrid = __webpack_require__(53);

var PackagesGrid = _interopRequireWildcard(_packagesGrid);

var _packagesSlider = __webpack_require__(55);

var PackagesSlider = _interopRequireWildcard(_packagesSlider);

var _pageHeader = __webpack_require__(57);

var PageHeader = _interopRequireWildcard(_pageHeader);

var _pageSidebar = __webpack_require__(59);

var PageSidebar = _interopRequireWildcard(_pageSidebar);

var _postContent = __webpack_require__(61);

var PostContent = _interopRequireWildcard(_postContent);

var _postsList = __webpack_require__(63);

var PostsList = _interopRequireWildcard(_postsList);

var _roomContent = __webpack_require__(65);

var RoomContent = _interopRequireWildcard(_roomContent);

var _roomsSlider = __webpack_require__(67);

var RoomsSlider = _interopRequireWildcard(_roomsSlider);

var _servicesContent = __webpack_require__(69);

var ServicesContent = _interopRequireWildcard(_servicesContent);

var _socials = __webpack_require__(71);

var Socials = _interopRequireWildcard(_socials);

var _twoColumns = __webpack_require__(73);

var TwoColumns = _interopRequireWildcard(_twoColumns);

var _topPage = __webpack_require__(75);

var TopPage = _interopRequireWildcard(_topPage);

var _zoneBoxes = __webpack_require__(77);

var ZoneBoxes = _interopRequireWildcard(_zoneBoxes);

var _zonesGrid = __webpack_require__(79);

var ZonesGrid = _interopRequireWildcard(_zonesGrid);

__webpack_require__(81);

__webpack_require__(82);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function importComponent(name) {
    if (name === 'accommodation-content') {
        return Promise.resolve(AccommodationContent);
    }

    if (name === 'accommodations-slider') {
        return Promise.resolve(AccommodationsSlider);
    }

    if (name === 'faq-list') {
        return Promise.resolve(FaqList);
    }

    if (name === 'footer') {
        return Promise.resolve(Footer);
    }

    if (name === 'full-slider') {
        return Promise.resolve(FullSlider);
    }

    if (name === 'info-bar') {
        return Promise.resolve(FullSlider);
    }

    if (name === 'page-header') {
        return Promise.resolve(PageHeader);
    }

    if (name === 'mobile-menu') {
        return Promise.resolve(MobileMenu);
    }

    if (name === 'offers-slider') {
        return Promise.resolve(OffersSlider);
    }

    if (name === 'packages-box') {
        return Promise.resolve(PackagesBox);
    }

    if (name === 'package-content') {
        return Promise.resolve(PackageContent);
    }

    if (name === 'home-packages') {
        return Promise.resolve(HomePackages);
    }

    if (name === 'room-content') {
        return Promise.resolve(RoomContent);
    }

    if (name === 'rooms-slider') {
        return Promise.resolve(RoomsSlider);
    }

    if (name === 'packages-slider') {
        return Promise.resolve(PackagesSlider);
    }

    if (name === 'services-content') {
        return Promise.resolve(ServicesContent);
    }

    if (name === 'socials') {
        return Promise.resolve(Socials);
    }
}

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.component = undefined;

__webpack_require__(17);

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _animejs = __webpack_require__(1);

var _animejs2 = _interopRequireDefault(_animejs);

var _image = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var component = exports.component = {
    name: 'accommodation-content',

    data: {
        accommodation: {},
        gallery: null,
        filters: {
            beds: null,
            bedrooms: null,
            service: null,
            bathrooms: null,
            area: null,
            kitchenette: null
        },
        map: null,
        order: 'desc',
        orderBy: 'beds',
        rooms: [],
        readMore: false,
        readMoreDisplay: false
    },

    computed: {
        filteredRooms: function filteredRooms() {
            var rooms = this.rooms;
            _lodash2.default.each(this.filters, function (filterValue, filter) {
                rooms = _lodash2.default.filter(rooms, function (room) {
                    if (filter === 'beds') {
                        if (!filterValue) {
                            return true;
                        } else if (filterValue < 5) {
                            return room.beds >= filterValue;
                        } else {
                            return room.beds >= 5;
                        }
                    } else if (filter === 'bedrooms') {
                        if (!filterValue) {
                            return true;
                        } else if (filterValue < 5) {
                            return room.bed_rooms === filterValue;
                        } else {
                            return room.bed_rooms >= 5;
                        }
                    } else if (filter === 'service') {
                        if (!filterValue) {
                            return true;
                        } else {
                            return _lodash2.default.findIndex(room.services, function (service) {
                                return service.slug === filterValue;
                            }) >= 0;
                        }
                    } else if (filter === 'bathrooms') {
                        if (!filterValue) {
                            return true;
                        } else {
                            return room.bathrooms === filterValue;
                        }
                    } else if (filter === 'area') {
                        if (!filterValue) {
                            return true;
                        } else {
                            if (filterValue === 1) {
                                return room.area < 40;
                            } else if (filterValue === 2) {
                                return _lodash2.default.inRange(room.area, 40, 61);
                            } else if (filterValue === 3) {
                                return room.area > 60;
                            }
                        }
                    } else if (filter === 'kitchenette') {
                        if (!filterValue) {
                            return true;
                        } else {
                            var hasService = !!_lodash2.default.find(room.services, function (service) {
                                return service.name === 'Angolo Cottura' || service.name === 'Kitchenette';
                            });
                            if (filterValue === 1) {
                                return hasService;
                            } else if (filterValue === 2) {
                                return !hasService;
                            }
                        }
                    }
                });
            });
            return rooms;
        },
        roomsList: function roomsList() {
            var _this = this;

            switch (this.orderBy) {
                case 'beds':
                    return _lodash2.default.orderBy(this.filteredRooms, 'beds', this.order);
                    break;
                case 'offers':
                    return _lodash2.default.orderBy(this.filteredRooms, function (room) {
                        return _this.offerActive(room);
                    }, this.order);
                    break;
                case 'type':
                    return _lodash2.default.orderBy(this.filteredRooms, 'type', this.order);
                    break;
                case 'area':
                    return _lodash2.default.orderBy(this.filteredRooms, 'area', this.order);
                    break;
                case 'bathrooms':
                    return _lodash2.default.orderBy(this.filteredRooms, 'bathrooms', this.order);
                    break;
            }
        }
    },

    mounted: function mounted() {
        var _this2 = this;

        this.googleMap();

        // service icons
        _lodash2.default.each(this.accommodation.services, function (service) {
            if (service.image_url) {
                Promise.resolve().then(function () {
                    return (0, _image.loadSvg)(service.image_url);
                }).then(function (svg) {
                    service.icon = svg.outerHTML;
                });
            }
        });

        // lightbox
        this.gallery = new LuminousGallery(this.$el.querySelectorAll('.accommodation-content__image'));

        _lodash2.default.defer(function () {
            if (_this2.$refs.innerContent.offsetHeight <= _this2.$refs.content.offsetHeight) {
                _this2.readMore = true;
            } else {
                _this2.readMoreDisplay = true;
            }
        });
    },


    methods: {
        googleMap: function googleMap() {
            var _this3 = this;

            if (!window.google) {
                setTimeout(function () {
                    return _this3.googleMap();
                }, 1000);
                return;
            }
            var position = {
                lat: parseFloat(this.accommodation.position.lat),
                lng: parseFloat(this.accommodation.position.lng)
            };

            this.map = new google.maps.Map(this.$refs.map, {
                center: position,
                zoom: 16
            });

            new google.maps.Marker({
                position: position,
                map: this.map
            });
        },
        offerActive: function offerActive(room) {
            if (room.offer) {
                var offerFromExploded = room.offer_from.split('/');
                var offerToExploded = room.offer_to.split('/');
                var offerFrom = new Date(offerFromExploded[2] + '-' + offerFromExploded[1] + '-' + offerFromExploded[0] + 'T00:00:00');
                var offerTo = new Date(offerToExploded[2] + '-' + offerToExploded[1] + '-' + offerToExploded[0] + 'T24:00:00');
                var now = new Date();
                return offerFrom <= now && now <= offerTo;
            } else {
                return false;
            }
        },
        resetFilters: function resetFilters() {
            this.filters.beds = null;
            this.filters.bedrooms = null;
            this.filters.service = null;
            this.filters.bathrooms = null;
            this.filters.area = null;
            this.filters.kitchenette = null;
        },
        scrollTo: function scrollTo(section) {
            var el = null;
            switch (section) {
                case 'rooms':
                    el = this.$refs.roomsSection;
                    break;
                case 'services':
                    el = this.$refs.servicesSection;
                    break;
                case 'map':
                    el = this.$refs.mapSection;
                    break;
            }
            var top = el.getBoundingClientRect().top;
            var obj = { top: window.pageYOffset };
            (0, _animejs2.default)({
                targets: obj,
                top: [window.pageYOffset, window.pageYOffset + top - 24],
                duration: 500,
                easing: 'easeInOutSine',
                update: function update() {
                    window.requestAnimationFrame(function () {
                        window.scrollTo(0, obj.top);
                    });
                }
            });
        },
        toggleFilter: function toggleFilter(filter, filterValue) {
            if (this.filters[filter] && this.filters[filter] === filterValue) {
                this.filters = _lodash2.default.assign(this.filters, _defineProperty({}, filter, null));
            } else {
                this.filters = _lodash2.default.assign(this.filters, _defineProperty({}, filter, filterValue));
            }
        },
        toggleOrder: function toggleOrder(orderBy) {
            if (orderBy === this.orderBy) {
                if (this.order === 'asc') {
                    this.order = 'desc';
                } else {
                    this.order = 'asc';
                }
            } else {
                this.orderBy = orderBy;
            }
        }
    }
};

/***/ }),
/* 17 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.component = undefined;

__webpack_require__(19);

var component = exports.component = {
    name: 'accommodations-slider',

    data: {
        accommodationIndex: 0
    },

    computed: {
        currentTab: function currentTab() {
            return this.tabs[this.tabsIndex];
        }
    },

    methods: {
        accommodationNext: function accommodationNext() {
            if (this.accommodationIndex < this.accommodations.length - 4) {
                this.accommodationIndex++;
            }
        },
        accommodationPrev: function accommodationPrev() {
            if (this.accommodationIndex > 0) {
                --this.accommodationIndex;
            }
        }
    }
};

/***/ }),
/* 19 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(21);

/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(23);

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.component = undefined;

__webpack_require__(25);

var component = exports.component = {
    name: 'faq-content',

    mounted: function mounted() {
        console.log('faqqq');
    }
};

/***/ }),
/* 25 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.component = undefined;

__webpack_require__(27);

var component = exports.component = {
    name: 'faq-list',

    data: {
        index: -1
    }
};

/***/ }),
/* 27 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.component = undefined;

__webpack_require__(29);

var _image = __webpack_require__(4);

var component = exports.component = {
    name: 'footer',

    mounted: function mounted() {
        this.socials.forEach(function (social) {
            var url = window.__themeUrl + '/assets/svg/social/' + social.social_icon;
            (0, _image.loadSvg)(url).then(function (svg) {
                return social.icon = svg.outerHTML;
            });
        });
    }
};

/***/ }),
/* 29 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(31);

/***/ }),
/* 31 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.component = undefined;

__webpack_require__(33);

var _fullSliderTweens = __webpack_require__(34);

var _image = __webpack_require__(4);

var component = exports.component = {
    name: 'full-slider',

    data: {
        id: null,
        index: 0,
        interactions: true,
        slides: [],
        slideTimeout: null,
        dateStart: null,
        dateEnd: null,
        dateRange: null,
        location: null,
        people: 1,
        children: 0,
        rooms: 1,
        overlayImageSrc: null,
        slideContent: true
    },

    computed: {
        currentSlide: function currentSlide() {
            if (this.slides[this.index]) {
                return this.slides[this.index];
            } else {
                return null;
            }
        },
        showPrev: function showPrev() {
            return this.index > 0;
        },
        showNext: function showNext() {
            return this.index < this.slides.length - 1;
        }
    },

    watch: {
        dateStart: function dateStart(value) {
            if (this.dateEnd === null) {
                this.dateEnd = value;
            }
        },
        dateEnd: function dateEnd(value) {
            if (value && this.dateStart) {
                if (value < this.dateStart) {
                    this.dateEnd = null;
                }
            }
        }
    },

    mounted: function mounted() {
        this.slideContent = !!(this.currentSlide && this.currentSlide.title);
        this.setSlideTimeout();
    },


    methods: {
        setSlideTimeout: function setSlideTimeout() {
            var _this = this;

            clearTimeout(this.slideTimeout);
            this.slideTimeout = setTimeout(function () {
                var nextIndex = _this.index + 1 === _this.slides.length ? 0 : _this.index + 1;
                _this.toggleSlide(nextIndex);
            }, 10000);
        },
        toggleNextSlide: function toggleNextSlide() {
            var nextIndex = this.index + 1;
            if (nextIndex === this.slides.length) {
                return;
            } else {
                this.toggleSlide(nextIndex);
            }
        },
        togglePrevSlide: function togglePrevSlide() {
            var nextIndex = this.index - 1;
            if (nextIndex < 0) {
                return;
            } else {
                this.toggleSlide(nextIndex);
            }
        },
        toggleSlide: function toggleSlide(i) {
            var _this2 = this;

            if (i === this.index) {
                return;
            }

            if (!this.interactions) {
                return;
            }

            if (!this.slides[i]) {
                return;
            }

            clearTimeout(this.slideTimeout);
            this.interactions = false;

            var onTransitionEnd = function () {
                this.index = i;
                this.overlayImageSrc = null;
                this.interactions = true;
                this.$refs.backgroundOverlay.removeEventListener('transitionend', onTransitionEnd);
            }.bind(this);

            Promise.resolve().then(function () {
                return (0, _image.loadImage)(_this2.slides[i].image.sizes.wide);
            }).then(function (img) {
                _this2.slideContent = !!_this2.slides[i].title;
                _this2.overlayImageSrc = img.src;
                _this2.$refs.backgroundOverlay.addEventListener('transitionend', onTransitionEnd);
            });
        },
        __toggleSlide: function __toggleSlide(i) {
            var _this3 = this;

            if (i === this.index) {
                return;
            }

            if (!this.interactions) {
                return;
            }

            clearTimeout(this.slideTimeout);
            this.interactions = false;

            Promise.resolve().then(function () {
                return Promise.all([_fullSliderTweens.tweenSlideOut.call(_this3), (0, _image.loadImage)(_this3.slides[i].image.sizes.wide)]);
            }).then(function () {
                _this3.index = i;
            }).then(function () {
                return _fullSliderTweens.tweenSlideIn.call(_this3);
            }).then(function () {
                _this3.interactions = true;
                _this3.setSlideTimeout();
            });
        },
        submit: function submit() {
            var _this4 = this;

            if (!(this.dateStart && this.dateEnd)) {
                return;
            }

            var from = this.dateStart;
            var to = this.dateEnd;

            if (!from) {
                return;
            } else {
                from = from.getDate() + '-' + (from.getMonth() + 1) + '-' + from.getFullYear();
            }

            if (!to) {
                return;
            } else {
                to = to.getDate() + '-' + (to.getMonth() + 1) + '-' + to.getFullYear();
            }

            var url = null;
            if (this.location) {
                var location = _.find(this.locations, function (location) {
                    return location.booking_id === _this4.location;
                });
                var locationBooking = location.booking;
                var locationBookingId = location.booking_id; // same as this.location

                if (locationBooking === 'fullboard') {
                    url = 'http://' + location.booking_account_name + '.fullboard.cloud/booking/prenota-hotel/' + locationBookingId + '_struttura.html?checkFilter=true&data_checkin=' + from + '&data_checkout=' + to + '&n_camere=1&room_number=1&n_adulti=' + this.people + '&n_bambini=' + this.children + '&trattamento=struttura';
                } else {
                    from = from.split('-');
                    from[0] = from[0].length === 1 ? '0' + from[0] : from[0];
                    from[1] = from[1].length === 1 ? '0' + from[1] : from[1];
                    from = from[2] + '-' + from[1] + '-' + from[0];

                    to = to.split('-');
                    to[0] = to[0].length === 1 ? '0' + to[0] : to[0];
                    to[1] = to[1].length === 1 ? '0' + to[1] : to[1];
                    to = to[2] + '-' + to[1] + '-' + to[0];

                    url = 'https://secure.kosmosol.it/booking/v2/check-availability.php?h=' + locationBookingId + '&l=' + this.currentLanguage + '&bd=' + from + '&ed=' + to;
                }
                window.open(url, '_blank');
            } else {
                // url = `http://bookingromaresort.fullboard.cloud/booking/prenota-ora.html?checkFilter=true&data_checkin=${from}&data_checkout=${to}&n_camere=1&n_adulti=${this.people}&n_bambini=${this.children}`
            }
        }
    }
};

/***/ }),
/* 33 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.tweenSlideOut = tweenSlideOut;
exports.tweenSlideIn = tweenSlideIn;

var _animejs = __webpack_require__(1);

var _animejs2 = _interopRequireDefault(_animejs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function tweenSlideOut() {
    // this.$refs.overlayLoader.style.transform = 'scaleX(0)'

    var tween = (0, _animejs2.default)({
        targets: this.$refs.overlayLoader,
        scaleX: [0, 1],
        opacity: [0, 1],
        duration: 500,
        easing: 'easeInOutQuint'
    });

    return tween.finished;
}

function tweenSlideIn() {
    var _this = this;

    var timeline = _animejs2.default.timeline();

    this.$refs.overlayLoader.style.transformOrigin = '0 50%';

    timeline.add({
        targets: this.$refs.overlayLoader,
        scaleX: [1, 0],
        duration: 500,
        easing: 'easeInOutQuint'
    });

    timeline.finished.then(function () {
        _this.$refs.overlayLoader.style.transformOrigin = null;
        _this.$refs.overlayLoader.style.transform = null;
        _this.$refs.overlayLoader.style.opacity = null;
    });

    return timeline.finished;
}

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.component = undefined;

__webpack_require__(36);

var component = exports.component = {
    name: 'home-packages',

    data: {
        active: false,
        index: 0,
        packages: [],
        timeout: null
    },

    computed: {
        positionX: function positionX() {
            return 100 / this.packages.length * -this.index + '%';
        },
        sliderWidth: function sliderWidth() {
            return 33.333333 * this.packages.length + '%';
        }
    },

    mounted: function mounted() {
        var _this = this;

        this.active = true;
        setTimeout(function () {
            return _this.setTimeout();
        }, 4000);
    },


    methods: {
        next: function next() {
            if (this.index + 1 > this.packages.length - 3) {
                return;
            }
            clearTimeout(this.timeout);
            this.index = this.index + 1;
        },
        prev: function prev() {
            if (this.index === 0) {
                return;
            }
            clearTimeout(this.timeout);
            this.index = this.index - 1;
        },
        setTimeout: function (_setTimeout) {
            function setTimeout() {
                return _setTimeout.apply(this, arguments);
            }

            setTimeout.toString = function () {
                return _setTimeout.toString();
            };

            return setTimeout;
        }(function () {
            var _this2 = this;

            clearTimeout(this.timeout);
            this.timeout = setTimeout(function () {
                var nextIndex = _this2.index + 1;
                if (nextIndex > _this2.packages.length - 3) {
                    nextIndex = 0;
                }
                _this2.index = nextIndex;
                _this2.setTimeout();
            }, 8000);
        })
    }
};

/***/ }),
/* 36 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(38);

/***/ }),
/* 38 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(40);

/***/ }),
/* 40 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(42);

/***/ }),
/* 42 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.component = undefined;

__webpack_require__(44);

var _eventBus = __webpack_require__(7);

var component = exports.component = {
    name: 'mobile-menu',

    data: {
        visible: false
    },

    watch: {
        visible: function visible(value) {
            if (value) {
                window.document.body.classList.add('unscrollable');
            } else {
                window.document.body.classList.remove('unscrollable');
            }
        }
    },

    mounted: function mounted() {
        var _this = this;

        _eventBus.EventBus.$on('MobileMenu.toggle', function () {
            _this.visible = !_this.visible;
        });
    },


    methods: {
        toggleMobileMenu: function toggleMobileMenu() {
            _eventBus.EventBus.$emit('MobileMenu.toggle');
        }
    }
};

/***/ }),
/* 44 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.component = undefined;

__webpack_require__(46);

var component = exports.component = {
    name: 'offers-slider',

    data: {
        active: false,
        index: 0,
        rooms: [],
        sliderX: 0,
        timeout: null
    },

    computed: {
        positionX: function positionX() {
            return 100 / this.rooms.length * -this.index + '%';
        },
        sliderWidth: function sliderWidth() {
            return 50 * this.rooms.length + '%';
        }
    },

    mounted: function mounted() {
        this.active = true;
        this.setTimeout();
    },


    methods: {
        isSmallScreen: function isSmallScreen() {
            var mqset = theme.mediaquery.get();
            var small = _.find(mqset, function (mqobj) {
                return mqobj.name === 'small';
            });
            var medium = _.find(mqset, function (mqobj) {
                return mqobj.name === 'medium';
            });
            return small.mql.matches || medium.mql.matches;
        },
        next: function next() {
            if (this.index + 1 === this.rooms.length - 1) {
                return;
            }

            if (this.isSmallScreen()) {
                return;
            }

            clearTimeout(this.timeout);
            this.index = this.index + 1;
        },
        prev: function prev() {
            if (this.index === 0) {
                return;
            }

            if (this.isSmallScreen()) {
                return;
            }

            clearTimeout(this.timeout);
            this.index = this.index - 1;
        },
        setTimeout: function (_setTimeout) {
            function setTimeout() {
                return _setTimeout.apply(this, arguments);
            }

            setTimeout.toString = function () {
                return _setTimeout.toString();
            };

            return setTimeout;
        }(function () {
            var _this = this;

            clearTimeout(this.timeout);

            if (this.rooms.length < 2) {
                return;
            }

            if (this.isSmallScreen()) {
                return;
            }

            this.timeout = setTimeout(function () {
                var nextIndex = _this.index + 1;
                if (nextIndex === _this.rooms.length - 1) {
                    nextIndex = 0;
                }
                _this.index = nextIndex;
                _this.setTimeout();
            }, 8000);
        })
    }
};

/***/ }),
/* 46 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(48);

/***/ }),
/* 48 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.component = undefined;

__webpack_require__(50);

var component = exports.component = {
    name: 'package-content',

    data: {
        contactFormState: 'hide',
        bookingUrl: null
    },

    mounted: function mounted() {
        console.log(this.urls);
    }
};

/***/ }),
/* 50 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.component = undefined;

__webpack_require__(52);

var component = exports.component = {
    name: 'packages-box'
};

/***/ }),
/* 52 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(54);

/***/ }),
/* 54 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.component = undefined;

__webpack_require__(56);

var _animejs = __webpack_require__(1);

var _animejs2 = _interopRequireDefault(_animejs);

var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var component = exports.component = {
    name: 'packages-slider',

    data: {
        index: 0,
        interactions: true,
        timeout: null
    },

    computed: {
        currentPackage: function currentPackage() {
            return this.packages[this.index] ? this.packages[this.index] : null;
        }
    },

    mounted: function mounted() {
        this.setTimeout();
    },


    methods: {
        next: function next(e) {
            if (e) {
                e.preventDefault();
            }
            var nextIndex = this.index + 1 === this.packages.length ? 0 : this.index + 1;
            this.toggle(nextIndex);
        },
        prev: function prev(e) {
            if (e) {
                e.preventDefault();
            }
            var nextIndex = this.index - 1 < 0 ? this.packages.length - 1 : this.index - 1;
            this.toggle(nextIndex);
        },
        setTimeout: function (_setTimeout) {
            function setTimeout() {
                return _setTimeout.apply(this, arguments);
            }

            setTimeout.toString = function () {
                return _setTimeout.toString();
            };

            return setTimeout;
        }(function () {
            var _this = this;

            clearTimeout(this.timeout);
            this.timeout = setTimeout(function () {
                return _this.next();
            }, 7500);
        }),
        toggle: function toggle(i) {
            var _this2 = this;

            if (!this.interactions) {
                return;
            }

            if (i === this.index) {
                return;
            }

            clearTimeout(this.timeout);
            this.interactions = false;

            Promise.resolve().then(function () {
                var tween = (0, _animejs2.default)({
                    targets: _this2.$refs.package,
                    opacity: [1, 0],
                    duration: 200,
                    easing: 'easeInOutQuad'
                });
                return tween.finished;
            }).then(function () {
                return new Promise(function (resolve) {
                    _this2.index = i;
                    _vue2.default.nextTick(function () {
                        return resolve();
                    });
                });
            }).then(function () {
                var tween = (0, _animejs2.default)({
                    targets: _this2.$refs.package,
                    opacity: [0, 1],
                    duration: 300,
                    easing: 'easeOutQuint'
                });
                return tween.finished;
            }).then(function () {
                _this2.interactions = true;
                _this2.setTimeout();
            });
        }
    }
};

/***/ }),
/* 56 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.component = undefined;

__webpack_require__(58);

var _eventBus = __webpack_require__(7);

var component = exports.component = {
    name: 'page-header',

    methods: {
        toggleMobileMenu: function toggleMobileMenu() {
            _eventBus.EventBus.$emit('MobileMenu.toggle');
        }
    }
};

/***/ }),
/* 58 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(60);

/***/ }),
/* 60 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(62);

/***/ }),
/* 62 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(64);

/***/ }),
/* 64 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.component = undefined;

__webpack_require__(66);

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _animejs = __webpack_require__(1);

var _animejs2 = _interopRequireDefault(_animejs);

var _image = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var component = exports.component = {
    name: 'room-content',

    data: {
        bookPosition: 'scroll',
        dateStart: null,
        dateEnd: null,
        // dateRange: null,
        gallery: null,
        people: 1,
        children: 0
    },

    watch: {
        'bookScroll.topVisible': function bookScrollTopVisible(visible) {
            this.bookScrollPosition();
        },

        'bookScroll.bottomVisible': function bookScrollBottomVisible(visible) {
            this.bookScrollPosition();
        },

        dateStart: function dateStart(value) {
            if (this.dateEnd === null) {
                this.dateEnd = value;
            }
        },
        dateEnd: function dateEnd(value) {
            if (value && this.dateStart) {
                if (value < this.dateStart) {
                    this.dateEnd = null;
                }
            }
        }
    },

    mounted: function mounted() {
        // map
        this.googleMap();

        // lightbox
        this.gallery = new LuminousGallery(this.$refs.imagesGrid.querySelectorAll('a'));

        // service icons
        _lodash2.default.each(this.room.services, function (service) {
            if (service.image_url) {
                Promise.resolve().then(function () {
                    return (0, _image.loadSvg)(service.image_url);
                }).then(function (svg) {
                    service.icon = svg.outerHTML;
                });
            }
        });

        // scroll listener
        if (!this.isSmallScreen()) {
            window.addEventListener('scroll', this.bookScrollListener);
        }
    },


    methods: {
        isSmallScreen: function isSmallScreen() {
            var mqset = window.theme.mediaquery.get();
            var small = _lodash2.default.find(mqset, function (mqobj) {
                return mqobj.name === 'small';
            });
            var medium = _lodash2.default.find(mqset, function (mqobj) {
                return mqobj.name === 'medium';
            });
            return small.mql.matches || medium.mql.matches;
        },
        googleMap: function googleMap() {
            var _this = this;

            if (!window.google) {
                setTimeout(function () {
                    return _this.googleMap();
                }, 1000);
                return;
            }
            var position = {
                lat: parseFloat(this.room.accommodation.position.lat),
                lng: parseFloat(this.room.accommodation.position.lng)
            };

            this.map = new google.maps.Map(this.$refs.map, {
                center: position,
                zoom: 16
            });

            new google.maps.Marker({
                position: position,
                map: this.map
            });
        },
        bookScrollListener: function bookScrollListener() {
            var columnRect = this.$refs.bookColumn.getBoundingClientRect();
            var wrapperRect = this.$refs.bookWrapper.getBoundingClientRect();

            if (columnRect.top <= 0 && columnRect.bottom - wrapperRect.height >= 0) {
                if (this.bookPosition !== 'fixed') {
                    this.bookPosition = 'fixed';
                }
            } else {
                if (columnRect.bottom - wrapperRect.height < 0) {
                    this.bookPosition = 'scroll-bottom';
                } else {
                    this.bookPosition = 'scroll';
                }
            }
        },
        scrollTo: function scrollTo(section) {
            var el = null;
            switch (section) {
                case 'description':
                    el = this.$refs.descriptionSection;
                    break;
                case 'images':
                    el = this.$refs.imagesSection;
                    break;
                case 'services':
                    el = this.$refs.servicesSection;
                    break;
                case 'map':
                    el = this.$refs.mapSection;
                    break;
            }
            var top = el.getBoundingClientRect().top;
            var obj = { top: window.pageYOffset };
            (0, _animejs2.default)({
                targets: obj,
                top: [window.pageYOffset, window.pageYOffset + top - 24],
                duration: 500,
                easing: 'easeInOutSine',
                update: function update() {
                    window.requestAnimationFrame(function () {
                        window.scrollTo(0, obj.top);
                    });
                }
            });
        },
        submit: function submit() {
            if (!(this.dateStart && this.dateEnd)) {
                return;
            }

            var from = this.dateStart;
            var to = this.dateEnd;

            if (this.room.accommodation.booking_engine === 'fullboard') {
                if (!from) {
                    return;
                } else {
                    from = from.getDate() + '-' + (from.getMonth() + 1) + '-' + from.getFullYear();
                }

                if (!to) {
                    return;
                } else {
                    to = to.getDate() + '-' + (to.getMonth() + 1) + '-' + to.getFullYear();
                }

                var url = 'http://' + this.room.accommodation.booking_account_name + '.fullboard.cloud/booking/prenota-hotel/' + this.room.accommodation.booking_id + '_struttura.html?checkFilter=true&data_checkin=' + from + '&data_checkout=' + to + '&n_camere=1&room_number=1&n_adulti=' + this.people + '&n_bambini=' + this.children + '&trattamento=struttura';
                window.open(url, '_blank');
            }

            if (this.room.accommodation.booking_engine === '5 stelle') {
                if (!from) {
                    return;
                } else {
                    from = [from.getFullYear().toString(), (from.getMonth() + 1).toString(), from.getDate().toString()];
                    from[1] = from[1].length === 1 ? '0' + from[1] : from[1];
                    from[2] = from[2].length === 1 ? '0' + from[2] : from[2];
                    from = from.join('-');
                }

                if (!to) {
                    return;
                } else {
                    to = [to.getFullYear().toString(), (to.getMonth() + 1).toString(), to.getDate().toString()];
                    to[1] = to[1].length === 1 ? '0' + to[1] : to[1];
                    to[2] = to[2].length === 1 ? '0' + to[2] : to[2];
                    to = to.join('-');
                }

                var _url = 'https://secure.kosmosol.it/booking/v2/check-availability.php?h=' + this.room.accommodation.booking_name + '&l=' + this.currentLanguage + '&bd=' + from + '&ed=' + to;
                window.open(_url, '_blank');
            }
        }
    }
};

/***/ }),
/* 66 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.component = undefined;

__webpack_require__(68);

var _animejs = __webpack_require__(1);

var _animejs2 = _interopRequireDefault(_animejs);

var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var component = exports.component = {
    name: 'rooms-slider',

    data: {
        index: 0,
        interactions: true,
        timeout: null
    },

    computed: {
        currentRoom: function currentRoom() {
            return this.rooms[this.index] ? this.rooms[this.index] : null;
        }
    },

    mounted: function mounted() {
        this.setTimeout();
    },


    methods: {
        next: function next(e) {
            if (e) {
                e.preventDefault();
            }
            var nextIndex = this.index + 1 === this.rooms.length ? 0 : this.index + 1;
            this.toggle(nextIndex);
        },
        prev: function prev(e) {
            if (e) {
                e.preventDefault();
            }
            var nextIndex = this.index - 1 < 0 ? this.rooms.length - 1 : this.index - 1;
            this.toggle(nextIndex);
        },
        setTimeout: function (_setTimeout) {
            function setTimeout() {
                return _setTimeout.apply(this, arguments);
            }

            setTimeout.toString = function () {
                return _setTimeout.toString();
            };

            return setTimeout;
        }(function () {
            var _this = this;

            clearTimeout(this.timeout);
            this.timeout = setTimeout(function () {
                return _this.next();
            }, 7500);
        }),
        toggle: function toggle(i) {
            var _this2 = this;

            if (!this.interactions) {
                return;
            }

            if (i === this.index) {
                return;
            }

            clearTimeout(this.timeout);
            this.interactions = false;

            Promise.resolve().then(function () {
                var tween = (0, _animejs2.default)({
                    targets: _this2.$refs.room,
                    opacity: [1, 0],
                    duration: 200,
                    easing: 'easeInOutQuad'
                });
                return tween.finished;
            }).then(function () {
                return new Promise(function (resolve) {
                    _this2.index = i;
                    _vue2.default.nextTick(function () {
                        return resolve();
                    });
                });
            }).then(function () {
                var tween = (0, _animejs2.default)({
                    targets: _this2.$refs.room,
                    opacity: [0, 1],
                    duration: 300,
                    easing: 'easeOutQuint'
                });
                return tween.finished;
            }).then(function () {
                _this2.interactions = true;
                _this2.setTimeout();
            });
        }
    }
};

/***/ }),
/* 68 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.component = undefined;

__webpack_require__(70);

var component = exports.component = {
    name: 'services-content',

    data: {
        tabsIndex: 0
    },

    computed: {
        currentTab: function currentTab() {
            return this.tabs[this.tabsIndex];
        }
    }
};

/***/ }),
/* 70 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.component = undefined;

__webpack_require__(72);

var _image = __webpack_require__(4);

var component = exports.component = {
    name: 'socials',

    mounted: function mounted() {
        var _this = this;

        this.socials.forEach(function (social, i) {
            var iconUrl = window.__themeUrl + '/assets/svg/social/' + social.social_icon;
            Promise.resolve().then(function () {
                return (0, _image.loadSvg)(iconUrl);
            }).then(function (svg) {
                _this.socials[i].icon = svg.outerHTML;
            });
        });
    }
};

/***/ }),
/* 72 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(74);

/***/ }),
/* 74 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(76);

/***/ }),
/* 76 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.component = undefined;

__webpack_require__(78);

var component = exports.component = {
    name: 'zone-boxes',

    data: {
        rooms: []
    },

    created: function created() {}
};

/***/ }),
/* 78 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(80);

/***/ }),
/* 80 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 81 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 82 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(6);

var _vuex2 = _interopRequireDefault(_vuex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import _ from 'lodash'
_vue2.default.use(_vuex2.default);

var store = new _vuex2.default.Store({
    state: {},
    mutations: {}
});

exports.default = store;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.add = add;
exports.remove = remove;
exports.get = get;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mqSet = [];

function add(params) {
    if (!(params && params.mediaquery)) {
        return;
    }
    if (!(params && params.name)) {
        return;
    }

    var mql = window.matchMedia(params.mediaquery);
    var className = 'mq-' + _lodash2.default.kebabCase(params.name);
    var mqObj = {
        mql: mql,
        name: params.name,
        listener: function listener() {
            window.document.body.classList[mql.matches ? 'add' : 'remove'](className);
        }
    };

    mqObj.listener();
    mql.addListener(mqObj.listener);
    mqSet.push(mqObj);
}

function remove(name) {
    var removed = _lodash2.default.remove(mqSet, function (mqObj) {
        return mqObj.name === name;
    });
    if (removed.length) {
        _lodash2.default.each(removed, function (mqObj) {
            mqObj.mql.removeListener(mqObj.listener);
        });
    }
    return !!removed.length;
}

function get() {
    return mqSet;
}

/***/ }),
/* 85 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[12]);


// WEBPACK FOOTER //
// app.js